import { useRef, useEffect, useState, useContext, createContext } from "react";
import { Amplify, Auth } from "aws-amplify";
import { iot, auth } from "aws-iot-device-sdk-v2";
import * as AWS from "aws-sdk";
import amplifyConfig from "../services/amplify-config";
import _ from "lodash";
import { usePreload } from "../contexts/preloading";
import api, { apiGeneral } from "../services/Api";
import { useUser } from "./user";
import { useAlert } from "./alert";
import {
  setStorageWithExpiry,
  getStorageWithExpiry,
  clearStorage,
} from "../shared/utils/functions.js";
import { mqttData } from "../assets/mqttData.js";
 
//new imports
import { storage } from "../utils/StorageHelper.js";
import mqtt from 'mqtt';


const Settings = require("../assets/settings");

Amplify.configure(amplifyConfig);
const AuthContext = createContext();

export default function AuthProvider({ children }) {
  const { user, setUser } = useUser();
  const { setPreloading } = usePreload();
  const { setClasseAlert, setAlertText, setAlertType } = useAlert();
  const myConnection = useRef(null);
  const [mqttUpdate, setMqttUpdate] = useState(null);
  const timerMqttAlive = useRef(null);
  const [mqttFailed, setMqttFailed] = useState(false);

  const login = async (usuario, senha) => {
    const username = usuario.trim();
    const password = senha.trim();

    let content = {
      userName: username,
      password: password
    };

    
    //var response = loginAPI.autenticacao(username, password)
    console.log("user here: ", username)
    console.log("senha?: ", password)
    //console.log("request success: ", response)
    
    setPreloading(true);
    // loginAPI.autenticacao(
    //   username,
    //   password,
    // )

    api.post(`/Account/Login`, content)
      .then((user) => {
        //salvando o token do localStorage
        console.log("Promise aqui: ", user)
        storage.setToken(user.data)

        const config = {
          headers: { Authorization: `Bearer ${storage.getToken()}`},
        };
        
        //Pegando infos do usuario 
        api.get(`/Account/GetLoggedInAccount`, config)
          .then((userInfo) =>{
            storage.setTokenUser(JSON.stringify(userInfo.data))
            //setUser(userInfo);
            return;
          })
          .catch((err) => {
            console.log(err);
            setPreloading(false);
            //setAlertText("Erro ao realzar login." + err);
          });
        // if (user.challengeName === "NEW_PASSWORD_REQUIRED") {
        //   setPreloading(false);

        //   const { requiredAttributes, userAttributes } = user.challengeParam;
        //   console.log(requiredAttributes, user);
        //   Auth.completeNewPassword(user, password, {})
        //     .then((res) => {
        //       console.log(res);
        //       setPreloading(false);
        //     })
        //     .catch((err) => {
        //       console.log(err);
        //       setPreloading(false);
        //     });
        // } else {



          setPreloading(false);
          console.log("Login realizado com sucesso");
          // return;
          window.location.href = "/";
        // }
      })
      .catch((err) => {
        console.log(err);
        setPreloading(false);
        let index = String(err).indexOf(":");
        let cleanError = String(err).substring(0, index);
        if (cleanError === "UserNotConfirmedException") {
          setAlertText("Cadastro não validado ainda.");
        } else {
          setAlertText("Ocorreu um erro.");
        }
        setAlertType("error");
        setClasseAlert("on");
      });
  };

  const logout = () => {
    setPreloading(true);
    //Auth.signOut();
    setTimeout(() => {
      setPreloading(false);
      localStorage.clear();
      window.location.href = "/";
    }, 1000);
  };

  // const MQTT_BROKER_URL = "wss://34.226.111.17:9001";
  // const MQTT_BROKER_URL = "wss://98.84.167.252:9001";
  // const MQTT_BROKER_URL = "wss://192.168.11.171:9001"; // importante: wss:// para navegador
  // const MQTT_BROKER_URL = "wss://app.plataformalucyio.com.br:9001";
  // const MQTT_BROKER_URL = "wss://mtqq.plataformalucyio.com.br:9001";


  let MQTT_TOPIC;

  let StorageItens = getStorageWithExpiry("@session");
  //console.log("StorageItens: ", StorageItens);
  if (StorageItens && StorageItens.ciclo && StorageItens.ciclo.macAddXxx && StorageItens.ciclo.macAddXxx.dbapP_TAGC) {
    MQTT_TOPIC = `LucyIO/Ciclo/STATUS/${StorageItens.ciclo.macAddXxx.dbapP_TAGC}/#`;
  } else {
    MQTT_TOPIC = "LucyIO/Ciclo/STATUS//#";
  }

  const MQTT_BROKER_URL = "wss://mtqq.plataformalucyio.com.br:9001";
  //const MQTT_TOPIC = "LucyIO/Ciclo/STATUS/Ciclo.01/#";
  const MQTT_USERNAME = "terapeuta";
  const MQTT_PASSWORD = "abc123_";

  const connectMqtt = async () => {
    
    const MAX_RETRIES = 5;
    let retryCount = 0;
    
    try { 
      if (!myConnection.current) {
        const userValues = JSON.parse(storage.getTokenUser());
        const userId = userValues.id;
    
        console.log("🔌 Conectando ao broker MQTT como:", userId);
        console.log("🔌 Conexão MQTT iniciada");
        setPreloading(true);

        const client = mqtt.connect(MQTT_BROKER_URL, {
          clientId: `client-${userId}`,
          username: MQTT_USERNAME,
          password: MQTT_PASSWORD,
          clean: true,
          reconnectPeriod: 0, // Desabilita reconexão automática
          keepalive: 30,
          connectTimeout: 10000,
          protocol: 'wss',
          //rejectUnauthorized: false // For self-signed certs
        })  
        
        client.on("error", (err) => {
          console.error("🚨 Erro na conexão MQTT:", err);

          console.error(`❌ Tentando reconectar ao MQTT (Tentativa ${retryCount + 1}/${MAX_RETRIES}):`, err.message);

          if (retryCount < MAX_RETRIES) {
            const delay = Math.pow(2, retryCount) * 1000; // Exponential backoff (1s, 2s, 4s)
            retryCount++;
            setTimeout(connectMqtt(), delay);
          } else {
            console.error('⚠️ Erro permanente de conexão ao MQTT.');
          }

          setPreloading(false);
        });
    
        client.on("connect", () => {
          console.log("✅ Conectado ao broker MQTT");
          retryCount = 0;
          myConnection.current = client;
          
          client.subscribe(MQTT_TOPIC, (err) => {
            if (err) {
              console.error("❌ Erro ao se inscrever no tópico:", err);
            } else {
              console.log(`📡 Inscrito no tópico: ${MQTT_TOPIC}`);
            }
          });
    
          setPreloading(false);
        });
    
        client.on("message", (topic, message) => {
          const msg = message.toString();
          //console.log(`📥 Mensagem recebida no tópico ${topic}: ${msg}`);
          
          subscribeMqttData(topic, message);
        });

        client.on("close", () => {
          console.log("🔌 Conexão MQTT encerrada");
        });
    
      } else {
        console.log("⚠️ MQTT já conectado");
      }
    } catch (error) {
      console.error("🚨 Erro ao conectar ao MQTT:", error);
      setPreloading(false);
    }
  
  };
  


  const publishMqtt = async (topic, message, qos, retained) => {
    if (!myConnection.current) {
      //await connectMqtt().then(() => {publishMqtt(topic, message, qos, retained);}).catch((err) => {console.log(err);});
    } else {
      for (let key in message) {
        message[key] = message[key].toString();
      }
      return await myConnection.current.publish(
        topic,
        JSON.stringify(message),
        { retain: true, qos: 1 },
        (err) => {
          if (err) {
            console.error('Publish error:', err);
          } 
        }
      );
    }
  };

  function replaceToNum(key, value) {
    if (typeof value === "string") {
      const valueNumber = Number(value);
      if (!Number.isNaN(valueNumber)) {
        return valueNumber.toString();
      }
    }
    return key === "TimeStamp" ? value.toString() + "Z" : value;
  }

  const subscribeMqtt = async (myTopic, qos) => {

    if (myConnection.current === null || myConnection.current === undefined) {
      connectMqtt()
        // .then((response) => {
        //   subscribeMqtt(myTopic, qos);
        // })
        // .catch((err) => {
        //   console.log(err);
        // });
    } else {
      console.log("Subscribing to topic:", myTopic);
      myConnection.current.subscribe(myTopic, qos)//, async (topic, payload) => {
      // console.log("Subscribed to topic:", topic);
      // console.log("Payload received:", payload);

        //   return
        //   const decoder = new TextDecoder("utf8");
        //   let message = decoder.decode(new Uint8Array(payload));
        //   let filterTopic = topic.split("/");
        //   filterTopic = filterTopic[filterTopic.length - 1];

        //   if (filterTopic !== "STS" && filterTopic !== "ATUACAO") {
        //     let mqttTemp = _.cloneDeep(mqttData);
        //     let tempSession = await getStorageWithExpiry("@session");

        //     if (filterTopic !== "CONFIGURASESSAO") {
        //       if (
        //         ((filterTopic === "ACOMPANHAMENTO" ||
        //           filterTopic === "INFORMACOESCORPORAIS") &&
        //           !_.isEqual(lastMessage, JSON.parse(message, replaceToNum))) ||
        //         filterTopic === "RESUMOCORRIDA" ||
        //         filterTopic === "ESTATISTICASESSAO"
        //       ) {
        //         lastMessage = JSON.parse(message, replaceToNum);
        //         if (filterTopic === "ACOMPANHAMENTO") {
        //           mqttTemp[filterTopic + "_RAW"] = JSON.parse(
        //             message,
        //             replaceToNum
        //           );
        //           mqttTemp[filterTopic].forEach((itemTopic) => {
        //             Object.entries(JSON.parse(message)).forEach(
        //               ([key, value]) => {
        //                 if (key === itemTopic.key) {
        //                   itemTopic.value = !Number.isNaN(Number(value))
        //                     ? key === "TimeStamp"
        //                       ? value.toString() + "Z"
        //                       : Number(value).toString()
        //                     : key === "TimeStamp"
        //                     ? value.toString() + "Z"
        //                     : value;
        //                 }
        //               }
        //             );
        //           });
        //           if (
        //             tempSession &&
        //             tempSession.data &&
        //             tempSession.data[filterTopic + "_RAW"]
        //           ) {
        //             if (
        //               !_.isEqual(
        //                 tempSession.data[filterTopic + "_RAW"][
        //                   tempSession.data[filterTopic + "_RAW"].length - 1
        //                 ],
        //                 mqttTemp[filterTopic + "_RAW"]
        //               )
        //             ) {
        //               let updateTemp = {
        //                 [filterTopic + "_RAW"]: mqttTemp[filterTopic + "_RAW"],
        //                 [filterTopic]: mqttTemp[filterTopic],
        //               };
        //               setMqttUpdate(updateTemp);
        //             }
        //           } else {
        //             let updateTemp = {
        //               [filterTopic + "_RAW"]: mqttTemp[filterTopic + "_RAW"],
        //               [filterTopic]: mqttTemp[filterTopic],
        //             };
        //             setMqttUpdate(updateTemp);
        //           }
        //         }
        //         if (filterTopic === "INFORMACOESCORPORAIS") {
        //           mqttTemp[filterTopic + "_RAW"] = JSON.parse(
        //             message,
        //             replaceToNum
        //           );
        //           mqttTemp[filterTopic].forEach((itemTopic) => {
        //             Object.entries(JSON.parse(message)).forEach(
        //               ([key, value]) => {
        //                 if (key === itemTopic.key) {
        //                   if (key === "Temperatura") {
        //                     itemTopic.value = !Number.isNaN(Number(value))
        //                       ? (Number(value) / 10).toString()
        //                       : value;
        //                   } else {
        //                     itemTopic.value = !Number.isNaN(Number(value))
        //                       ? Number(value).toString()
        //                       : value;
        //                   }
        //                 }
        //               }
        //             );
        //           });

        //           if (
        //             tempSession &&
        //             tempSession.data &&
        //             tempSession.data[filterTopic + "_RAW"]
        //           ) {
        //             if (
        //               !_.isEqual(
        //                 tempSession.data[filterTopic + "_RAW"][
        //                   tempSession.data[filterTopic + "_RAW"].length - 1
        //                 ],
        //                 mqttTemp[filterTopic + "_RAW"]
        //               )
        //             ) {
        //               let updateTemp = {
        //                 [filterTopic + "_RAW"]: mqttTemp[filterTopic + "_RAW"],
        //                 [filterTopic]: mqttTemp[filterTopic],
        //               };
        //               setMqttUpdate(updateTemp);
        //             }
        //           } else {
        //             let updateTemp = {
        //               [filterTopic + "_RAW"]: mqttTemp[filterTopic + "_RAW"],
        //               [filterTopic]: mqttTemp[filterTopic],
        //             };
        //             setMqttUpdate(updateTemp);
        //           }
        //         }
        //         if (filterTopic === "RESUMOCORRIDA") {
        //           mqttTemp[filterTopic + "_RAW"] = {
        //             ...JSON.parse(message, replaceToNum),
        //           };

        //           setMqttUpdate({
        //             [filterTopic + "_RAW"]: mqttTemp[filterTopic + "_RAW"],
        //           });
        //         }
        //         if (filterTopic === "ESTATISTICASESSAO") {
        //           mqttTemp[filterTopic + "_RAW"] = {
        //             ...JSON.parse(message, replaceToNum),
        //           };
        //           setMqttUpdate({
        //             [filterTopic + "_RAW"]: mqttTemp[filterTopic + "_RAW"],
        //           });
        //         }
        //       } else {
        //         JSON.parse(message, replaceToNum);
        //       }
        //     } else {
        //       JSON.parse(message, replaceToNum);
        //     }

        //     try {
        //       clearTimeout(timerMqttAlive.current);
        //     } catch (err) {}
        //     timerMqttAlive.current = setTimeout(() => {
        //       mqttIsNotAlive();
        //     }, 60000);
        //   }
        // })
        // .then((res) => {
        //   console.log("conn mqtt", res);
        // })
        // .catch((err) => {
        //   console.log("conn err", err);
        // });
    }
  };

  const subscribeMqttData = async (topic, payload) => {
    let lastMessage = {};

    const decoder = new TextDecoder("utf8");
    let message = decoder.decode(new Uint8Array(payload));
    let filterTopic = topic.split("/");
    filterTopic = filterTopic[filterTopic.length - 1];

    if (filterTopic !== "STS" && filterTopic !== "ATUACAO") {
      let mqttTemp = _.cloneDeep(mqttData);
      let tempSession = await getStorageWithExpiry("@session");
      
      if (filterTopic !== "CONFIGURASESSAO") {
        if (
          ((filterTopic === "ACOMPANHAMENTO" ||
            filterTopic === "INFORMACOESCORPORAIS") &&
            !_.isEqual(lastMessage, JSON.parse(message, replaceToNum))) ||
          filterTopic === "RESUMOCORRIDA" ||
          filterTopic === "ESTATISTICASESSAO"
        ) {
          lastMessage = JSON.parse(message, replaceToNum);
          if (filterTopic === "ACOMPANHAMENTO") {
            mqttTemp[filterTopic + "_RAW"] = JSON.parse(
              message,
              replaceToNum
            );
            mqttTemp[filterTopic].forEach((itemTopic) => {
              Object.entries(JSON.parse(message)).forEach(
                ([key, value]) => {
                  if (key === itemTopic.key) {
                    itemTopic.value = !Number.isNaN(Number(value))
                      ? key === "TimeStamp"
                        ? value.toString() + "Z"
                        : Number(value).toString()
                      : key === "TimeStamp"
                      ? value.toString() + "Z"
                      : value;
                  }
                }
              );
            });
            if (
              tempSession &&
              tempSession.data &&
              tempSession.data[filterTopic + "_RAW"]
            ) {
              if (
                !_.isEqual(
                  tempSession.data[filterTopic + "_RAW"][
                    tempSession.data[filterTopic + "_RAW"].length - 1
                  ],
                  mqttTemp[filterTopic + "_RAW"]
                )
              ) {
                let updateTemp = {
                  [filterTopic + "_RAW"]: mqttTemp[filterTopic + "_RAW"],
                  [filterTopic]: mqttTemp[filterTopic],
                };
                setMqttUpdate(updateTemp);
              }
            } else {
              let updateTemp = {
                [filterTopic + "_RAW"]: mqttTemp[filterTopic + "_RAW"],
                [filterTopic]: mqttTemp[filterTopic],
              };
              setMqttUpdate(updateTemp);
            }
          }
          if (filterTopic === "INFORMACOESCORPORAIS") {
            mqttTemp[filterTopic + "_RAW"] = JSON.parse(
              message,
              replaceToNum
            );
            mqttTemp[filterTopic].forEach((itemTopic) => {
              Object.entries(JSON.parse(message)).forEach(
                ([key, value]) => {
                  if (key === itemTopic.key) {
                    if (key === "Temperatura") {
                      itemTopic.value = !Number.isNaN(Number(value))
                        ? (Number(value) / 10).toString()
                        : value;
                    } else {
                      itemTopic.value = !Number.isNaN(Number(value))
                        ? Number(value).toString()
                        : value;
                    }
                  }
                }
              );
            });

            if (
              tempSession &&
              tempSession.data &&
              tempSession.data[filterTopic + "_RAW"]
            ) {
              if (
                !_.isEqual(
                  tempSession.data[filterTopic + "_RAW"][
                    tempSession.data[filterTopic + "_RAW"].length - 1
                  ],
                  mqttTemp[filterTopic + "_RAW"]
                )
              ) {
                let updateTemp = {
                  [filterTopic + "_RAW"]: mqttTemp[filterTopic + "_RAW"],
                  [filterTopic]: mqttTemp[filterTopic],
                };
                setMqttUpdate(updateTemp);
              }
            } else {
              let updateTemp = {
                [filterTopic + "_RAW"]: mqttTemp[filterTopic + "_RAW"],
                [filterTopic]: mqttTemp[filterTopic],
              };
              setMqttUpdate(updateTemp);
            }
          }
          if (filterTopic === "RESUMOCORRIDA") {
            mqttTemp[filterTopic + "_RAW"] = {
              ...JSON.parse(message, replaceToNum),
            };

            setMqttUpdate({
              [filterTopic + "_RAW"]: mqttTemp[filterTopic + "_RAW"],
            });
          }
          if (filterTopic === "ESTATISTICASESSAO") {
            mqttTemp[filterTopic + "_RAW"] = {
              ...JSON.parse(message, replaceToNum),
            };
            setMqttUpdate({
              [filterTopic + "_RAW"]: mqttTemp[filterTopic + "_RAW"],
            });
          }
        } else {
          JSON.parse(message, replaceToNum);
        }
      } else {
        JSON.parse(message, replaceToNum);
      }

      try {
        clearTimeout(timerMqttAlive.current);
      } catch (err) {}
        timerMqttAlive.current = setTimeout(() => {
        mqttIsNotAlive();
        console.log("MQTT is not alive, setting mqttFailed to true");
      }, 60000);
    }
  }

  const unsubscribeMqtt = async (myTopic) => {
    try {
      clearTimeout(timerMqttAlive.current);
    } catch (err) {}
    if (!myConnection.current) {
      await connectMqtt();
      //unsubscribeMqtt(myTopic);
    } else {
      myConnection.current
        .unsubscribe(myTopic, (err) => {
          if (err) {
            console.error("Unsubscribe error:", err);
          } else {
            console.log(`Unsubscribed from topic: ${myTopic}`);
          }
        })
    }
  };

  const mqttIsNotAlive = () => {
    setMqttFailed(true);
  };

  useEffect(() => {
    //console.log("mqttUpdate: ", mqttUpdate);
    if (mqttUpdate) {
    }
  }, [mqttUpdate]);

  const updateUserStorage = (newUser) => {
    setUser(newUser);
    localStorage.setItem('user', JSON.stringify(newUser)); // se quiser salvar
  };

  return (
    <AuthContext.Provider
      value={{
        user,
        setUser,
        login,
        logout,
        myConnection,
        connectMqtt,
        publishMqtt,
        subscribeMqtt,
        unsubscribeMqtt,
        mqttUpdate,
        setMqttUpdate,
        mqttFailed,
        setMqttFailed,
        updateUserStorage
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}



export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) throw new Error("useAuth must be used within a AuthProvider");
  const {
    isAuth,
    user,
    setUser,
    login,
    logout,
    myConnection,
    connectMqtt,
    publishMqtt,
    subscribeMqtt,
    unsubscribeMqtt,
    mqttUpdate,
    setMqttUpdate,
    mqttFailed,
    setMqttFailed,
    updateUserStorage
  } = context;
  return {
    isAuth,
    user,
    setUser,
    login,
    logout,
    myConnection,
    connectMqtt,
    publishMqtt,
    subscribeMqtt,
    unsubscribeMqtt,
    mqttUpdate,
    setMqttUpdate,
    mqttFailed,
    setMqttFailed,
    updateUserStorage
  };
}

export const protectedRoute =
  (Comp, route = "/login") =>
  (props) => {
    const { setPreloading } = usePreload();
    const { user, setUser } = useUser();

    const getUserData = () => {
      try {
        const config = {
          headers: { Authorization: `Bearer ${storage.getToken()}`},
        };
        
        api.get(`/Account/GetLoggedInAccount`, config)
          .then((response) => {
            //console.log("getUserData: ", response);

            if (response.status !== 200 || !response.data) {
              //Tratamento erro 401 
              if (response.status === 401) {
                console.log("Erro 401 - Não autorizado. Redirecionando para login...");
                localStorage.clear();
                window.location.href = "/Login";
                return;
              }
              //Para demais erros
              console.log("Erro na requisição:", response.data?.message || response.statusText);
              window.location.href = "/Login";
              return;
            }

            //Caminho top
            loadUserBasic().then((loadUser) => {
              //console.log("Load User teste: ", loadUser)
              storage.setTokenUser(JSON.stringify(loadUser))
              setUser({...loadUser, ...response.data});
            });
          })
          .catch((error) => {
            // Em caso de erro na requisição
            console.log("Erro ao buscar usuário:", error);
            window.location.href = "/Login";
          });

        
      } catch (err) {
          console.log("Erro:", err);
          setPreloading(false);
          window.location.href = "/Login";
      }
    }

    useEffect(() => {
      //setUser({currentRole: "Medico"})
      getUserData();
      //checkAuthState();
    }, []);
    return <Comp {...props} />;
  };




export const getJwtToken = async () => {
  // Auth.currentSession() checks if token is expired and refreshes with Cognito if needed automatically
  const session = await Auth.currentSession();
  return session.idToken.jwtToken;
};

export const loadUserBasic = async () => {
  
  const config = {
    headers: { Authorization: `Bearer ${storage.getToken()}`},
  };

  const config2 = {
    headers: { Authorization: `Bearer ${storage.getToken()}`},
    // responseType: "arraybuffer",
  };

  return (
    api
      // .get(`/Account/GetLoggedInAccount`, config)
      .get(`/Application/GetCurrentUserBasic`, config)
      .then(async (res) => {
        if (res.status === 200) {

          ////console.log(res.data);
          let tempData = res.data;

          let currentRole = getStorageWithExpiry("@currentRole");

          if (!currentRole) {
            setStorageWithExpiry(
              "@currentRole",
              res.data.roles[0].id,
              86400000
            );
          } else {
            let roleExist =
              res.data.roles.filter((role) => role.id === currentRole).length >
              0;
            if (!roleExist) {
              setStorageWithExpiry(
                "@currentRole",
                res.data.roles[0].id,
                86400000
              );
            }
          }

          tempData.currentRole = currentRole;

          if (res.data.photo !== null) {
            return api
              .get(res.data.photo, config2)
              .then(async (res2) => {
                tempData.photo = `data:image/jpeg;base64,${res2.data}`;
                return tempData;
              })
              .catch((error) => {
                console.log(error);
              });
          } else {
            return tempData;
          }
        }
      })
      .catch((error) => {
        console.log(error);
        if (error.response.status === 403) {
          Auth.signOut();
          setTimeout(() => {
            clearStorage("@currentRole");
            window.location.href = "/";
          }, 1000);
        }
      })
  );
};

async function connect_websocket(provider) {
  return new Promise((resolve, reject) => {
    let config =
      iot.AwsIotMqttConnectionConfigBuilder.new_builder_for_websocket()
        .with_clean_session(true)
        .with_client_id("")
        .with_endpoint(Settings.AWS_IOT_ENDPOINT)
        .with_credential_provider(provider)
        .with_use_websockets()
        .with_keep_alive_seconds(30)
        .build();

    const client = new mqtt.MqttClient();

    const connection = client.new_connection(config);
    connection.on("connect", (session_present) => {
      resolve(connection);
    });
    connection.on("interrupt", (error) => {});
    connection.on("resume", (return_code, session_present) => {});
    connection.on("disconnect", () => {});
    connection.on("error", (error) => {
      reject(error);
    });
    connection.connect();
  });
}

export class AWSCognitoCredentialsProvider extends auth.CredentialsProvider {
  constructor(options, expire_interval_in_ms) {
    super();
    this.options = options;
    AWS.config.region = options.Region;
    this.source_provider = new AWS.CognitoIdentityCredentials({
      IdentityPoolId: options.IdentityPoolId,
    });
    this.aws_credentials = {
      aws_region: options.Region,
      aws_access_id: this.source_provider.accessKeyId,
      aws_secret_key: this.source_provider.secretAccessKey,
      aws_sts_token: this.source_provider.sessionToken,
    };

    setInterval(async () => {
      await this.refreshCredentialAsync();
    }, expire_interval_in_ms ?? 3600 * 1000);
  }

  getCredentials() {
    return this.aws_credentials;
  }

  async refreshCredentialAsync() {
    return new Promise((resolve, reject) => {
      this.source_provider.get((err) => {
        if (err) {
          reject("Failed to get cognito credentials.");
        } else {
          this.aws_credentials.aws_access_id = this.source_provider.accessKeyId;
          this.aws_credentials.aws_secret_key =
            this.source_provider.secretAccessKey;
          this.aws_credentials.aws_sts_token =
            this.source_provider.sessionToken;
          this.aws_credentials.aws_region = this.options.Region;
          resolve(this);
        }
      });
    });
  }
}
